import React from 'react'

export default function Price() {
  return (
    <>
      <section className="ptb-40 bg-2" id="rates">
        <div className="container">
            <h2>💫Riya Dubey – Services & Price List💫</h2>
            
        </div>
    </section>
    </>
  )
}
